import { ModulesConfigMap, ModulesMap } from '../data/modulesMaps'
import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	getFuelStations: {
		useCache: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATIONS].GET_FUEL_STATIONS,
	},
	postFuelStation: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATIONS].POST_FUEL_STATION,
	},
	getFuelStation: {
		useCache: true,
		isSingleCachedEntity: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATIONS].GET_FUEL_STATION,
	},
	getFuelStationPreview: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATIONS].GET_FUEL_STATION_PREVIEW,
	},
	getFuelStationPopup: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATIONS].GET_FUEL_STATION_POPUP,
	},
	putFuelStation: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATIONS].PUT_FUEL_STATION,
	},
	patchFuelStation: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATIONS].PATCH_FUEL_STATION,
	},
	deleteFuelStation: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATIONS].DELETE_FUEL_STATION,
	},
}
